<!--  -->
<template>
 <div class="footer">
        <div class="info">
          <div class="phone">{{ webConfig.phone || "028-4554-4567" }}</div>
          <div class="records">
            <p></p>
            <!-- <p>内容纠错 | 使用帮助| 关于我们| 隐私声明| 网站地图| 网站建议</p> -->
            <p>www.zhcpw.org.cn 版权所有 主办单位：北京软数信息技术研究院 联系我们: {{ webConfig.phone }}</p>
            <p>网站标识码: {{ webConfig.copyright }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  <a href="https://beian.miit.gov.cn/" target="_blank" style="color:#fff">ICP备案号: {{ webConfig.recodenum }}</a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<img src="/static/img/police.png"
                            width="73" height="78" style="width: 29px; height: 31px;">京公网安备11010602201225 </span></p>
            <!-- <p>技术支持：<a href="http://www.beijsci.com" target="_blank" style="color:#fff">北捷科技</a></p>
          <p>{{ copyright }}  &nbsp;|&nbsp; {{ recodenum }}</p>
          <p>电话：{{ mobile }}  &nbsp;|&nbsp; E-mail：{{ email }}</p>  -->
            <!-- <p>QQ：739436060 | 法律顾问：王蔚律师</p> -->
          </div>
          <!-- <div class="qrcode right">
              <img width="125" height="125" :src="rightcodepic ? `${IP_TEST}/uploads/${rightcodepic}` : '/static/img/rightcodepic.jpg'">
          </div>
          <a class="right" href="javascript:;">{{ rightcodetext }}</a> -->
          <div class="qrcode">
            <img width="125" height="125" :src="webConfig.logopic ? `${IP_TEST}/uploads/${webConfig.logopic}` : '/static/img/leftcodepic.png'">
          </div>
          <a href="javascript:;">{{ webConfig.leftcodetext||'关注我们' }}</a>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      IP_TEST: "",
      webConfig: {
        copyright: "",
        recodenum: "",
        address: "",
        email: "",
        name: "",
        phone: "",
        mobile: "",
        shortname: "",
        leftcodepic: "",
        rightcodepic: "",
        leftcodetext: "",
        rightcodetext: ""
      }
    }
  },

  components: {},

  computed: {},

  mounted(){
      this.$axios.get("/api/webConfigs").then(res => {
        if(res.data&&res.data.data.length>0)
        {
            this.webConfig = res.data.data[0];
        }
    }); 
  },

  methods: {}
}

</script>
<style scoped>
.footer{
  position: relative;
  margin-top: 64px;
  height: 289px;
  background: #4462CF;
  background-image: url(/static/img/weibu.png);
}
.footer>.info{
  position: relative;
  margin: 0 auto;
  height: 282px;
  width: 1200px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
}
.footer>.info>.phone{
  position: absolute;
  top:80px;
  left: 8px;
  font-size: 47px;
  font-family: Helvetica;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 47px;
  font-style:italic;
}
.records{
  position: absolute;
  top:141px;
  left: 0px;
  width: 984px;
  height: 120px;
  line-height: 42px;
  overflow: hidden;
}
.records>p{
  margin-bottom: 28px;
  height: 16px;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  line-height: 16px;
  opacity: 0.8;
}
.qrcode{
  position: absolute;
  top:61px;
  right:3px;
  width: 135px;
  height: 135px;
  background: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer>.info>div.right{
  top:61px;
  right:180px;
}
.footer>.info>a.right{
  right:180px;
}
.footer>.info>a{
  position: absolute;
  width: 135px;
  top:216px;
  right: 4px;
  height: 18px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 18px;
  text-align: center;
  letter-spacing: 8px;
  
}
.footer>.info>a::before,.footer>.info>a::after{
  position: absolute;
  top:8.5px;
  content: '';
  background: #FFFFFF;
  width: 4px;
  height: 4px;
background: #FFFFFF;
border-radius: 50%;
}
.footer>.info>a::before{
  left: 0;
}
.footer>.info>a::after{
  right: 0;
}
</style>